// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footer-text":"Footer_footer-text__9g+XY","footer-link":"Footer_footer-link__IPChy"};